<div class="admin-container">
  <a class="nav-item" [class.active]="isCurrentRoute('articles')" routerLink="./articles"
    >Articles</a
  >
  <a class="nav-item" [class.active]="isCurrentRoute('accomodations')" routerLink="./accomodations"
    >Logements</a
  >
  <a class="nav-item" [class.active]="isCurrentRoute('destinations')" routerLink="./destinations"
    >Destinations</a
  >
  <a class="nav-item" [class.active]="isCurrentRoute('setup')" routerLink="./setups">Matériel</a>
  <a class="nav-item" [class.active]="isCurrentRoute('files')" routerLink="./files">Fichiers</a>
  <a class="nav-item" [class.active]="isCurrentRoute('tags')" routerLink="./tags">Tags</a>
  <a class="nav-item" [class.active]="isCurrentRoute('publish')" routerLink="./publish">Publier</a>
</div>
